import React, {useEffect, useState} from "react";
import {
    Box,
    Button,
    Typography,
    IconButton,
    Fade,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CommonDialog from "../Shared/CommonDialog/CommonDialog";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import styles from "./GuardianSlider.module.scss";
import {appendHistoryText} from "../../Helpers/Helpers";

interface Guardian {
    name: string;
    image: string;
    guardian: string;
    message?: string;
    backstory: string;
}

const guardians: Guardian[] = [
    {
        name: "Cyborg Bear",
        guardian: "CyborgBear",
        image: `${process.env.PUBLIC_URL}/assets/cyborg-bear-1.png`,
        message: `You can call me "Cyborg Bear". How may I help you now?`,
        backstory: `Cyborg Bear was an injured baby bear that was saved by benevolent aliens. He was inbued with alien technology that gave him special capabilities still not fully known. Currently, what is known is that Cyborg Bear is able to connect to any device and the internet to scan for information, and his love for knowledge, together with his enhanced wisdom, allows him to make very wise and make informed decisions despite his young age and beary nature.`
    },
    {
        name: "Zombie Myles",
        guardian: "CyborgBear",
        image: `${process.env.PUBLIC_URL}/assets/zombie-myles-7.png`,
        message: `Hello, I am Zombie Myles. Ga ga ga... What would you like done?`,
        backstory: `Zombie Myles was born into an environment that was highly radiated with strange and unknown chemicals and other agents. Growing up in a tough environment, Myles developed a strong sense of determination and willpower, leading to a focus that is unbreakable. Myles wants to stop the people who created such a bad environment, and decided on the title of "Zombie" to match this unbreakable will and determination. Myle's energy is directed against the evil people who cheat and does harm to others and Myles vow to bring the fight to his adversaries.`
    },
    {
        name: "Super Puppy",
        guardian: "CyborgBear",
        image: `${process.env.PUBLIC_URL}/assets/super_puppy_2.png`,
        message: `Piu! Piu! I am Super Puppy. I want to help you. What do you need me to do?`,
        backstory: `Super Puppy was just a baby when he ate an unknown substance of magical nature. This gave Super Puppy special powers of flight and speed, among other yet undiscovered powers. Given his helpful and carefree nature, Super Puppy feels a need to do good and help people in need, trying to achieve as much as he can in the name of good and happiness, while being cute.`
    },
    {
        name: "The Twins - Kungfu Bears",
        guardian: "CyborgBear",
        message: `We are "The Twins". Let us be of service to you.`,
        image: `${process.env.PUBLIC_URL}/assets/kungfu_bear_2.png`,
        backstory: `The Twins are a set of stoic and quiet bears who came down from the mountains. They are of unknown origin but possesses great Kung-fu strength and skills. They seem to be interested in protecting their friends and "family" and people in need. They act as true guardians and protectors of good people and society, and are inbued with an internal strength and discipline that come with their training and upbringing in the mountains.`
    },
    {
        name: "P & P Observation Unit: Poodie and Panda",
        guardian: "CyborgBear",
        message: `Hello. We are P&P Observation Unit. How may we be of service?`,
        image: `${process.env.PUBLIC_URL}/assets/poodie_and_panda_1.png`,
        backstory: `P&P Observation Unit is made up of two friends of a different nature but with similar hobbies and capabilities. Panda is mainly silent and loves to observe from a distance, having keen senses and being astute at interpreting and understanding, from a wisdom perspective. Poodie is a roving poodle who shares Panda's love of observation, interpretation and understanding. Poodie's innocent and non-threathening nature allows him to get close to the action to observe, while Panda prefers observing from afar and discreetly. The Unit gathers information from all sources to help The Guardians to do their job, fighting scammers all around the world.`
    },
];

export const GuardianSlider = ({
                                   onSelect,
                               }: {
    onSelect: (g: Guardian) => void;
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fadeIn, setFadeIn] = useState(true);
    const [showStoryBackGround, setShowStoryBackGround] = useState(false);
    const [selectedGuardian, setSelectedGuardian] = useState<Guardian | null>(null);

    useEffect(() => {
        const stored = localStorage.getItem("selectedGuardian");
        if (stored) {
            const guardianSelected = JSON.parse(stored);
            const guardianSelectedIndex = guardians.findIndex(
                (g) => g.name === guardianSelected.name
            );
            if (guardianSelectedIndex >= 0) {
                setFadeIn(false);
                setTimeout(() => {
                    setCurrentIndex(guardianSelectedIndex);
                    setSelectedGuardian(guardianSelected);
                    setFadeIn(true);
                }, 100);
            }
        }
    }, []);

    const handlePrev = () => {
        setFadeIn(false);
        setTimeout(() => {
            const newIndex = currentIndex === 0 ? guardians.length - 1 : currentIndex - 1;
            setCurrentIndex(newIndex);
            setFadeIn(true);
            setSelectedGuardian(guardians[newIndex]);
        }, 100);
    };

    const handleNext = () => {
        setFadeIn(false);
        const newIndex = currentIndex === guardians.length - 1 ? 0 : currentIndex + 1;
        setTimeout(() => {
            setCurrentIndex(newIndex);
            setFadeIn(true);
            setSelectedGuardian(guardians[newIndex]);
        }, 100);
    };

    const handleSelect = () => {
        onSelect(guardians[currentIndex]);
    };

    return (
        <Box className={styles.sliderContainer}>
            <IconButton onClick={handlePrev} className={styles.arrowLeft}>
                <ArrowBackIosNewIcon/>
            </IconButton>

            <Fade in={fadeIn} timeout={300}>
                <img
                    src={guardians[currentIndex].image}
                    alt={guardians[currentIndex].name}
                    className={styles.guardianImage}
                />
            </Fade>

            <Typography variant="h6" className={styles.guardianName}>
                {guardians[currentIndex].name}
            </Typography>

            <Box className={styles.actionBox}>
                <Button
                    onClick={handleSelect}
                    fullWidth
                    className={`choose-guardian-btn ${styles.chooseButton}`}
                    variant="contained"
                >
                    CHOOSE
                    <HelpOutlineIcon
                        className="muiButtonIcon"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowStoryBackGround(true);
                        }}
                        sx={{
                            cursor: "pointer",
                            position: "absolute",
                            right: -28,
                        }}
                    />
                </Button>
            </Box>

            <IconButton
                onClick={handleNext}
                className={`guardian-arrow-right ${styles.arrowRight}`}
            >
                <ArrowForwardIosIcon/>
            </IconButton>

            <CommonDialog
                open={showStoryBackGround}
                title={`${guardians[currentIndex].name}'s Back Story`}
                imageSrc={guardians[currentIndex].image}
                content={guardians[currentIndex].backstory}
                onClose={() => setShowStoryBackGround(false)}
                showActions={false}
                confirmText="Save"
                cancelText="Cancel"
            />
        </Box>
    );
};
